import { useEffect, useState } from 'react';
import { MapContextProvider, Props } from '@/hooks/useMap';
import { IRegion } from '@/types/explorer';
import RegionMap from './RegionMap';

export const RegionMapWrapper = ({
  region,
  regions,
}: {
  region: IRegion;
  regions: IRegion[];
}) => {
  const [screenWidth, setScreenWidth] = useState<number | undefined>();
  useEffect(() => {
    if (window) {
      setScreenWidth(window.innerWidth);
    }
  }, []);
  const mapContextProps: Props = {
    regionName: region.name,
    regions: regions,
    screenWidth: screenWidth,
    mapType: 'coverage',
    options: {
      enableStyles: false,
      enableLocation: true,
      enableSearch: false,
      rememberLocation: false,
    },
  };
  return (
    <MapContextProvider {...mapContextProps}>
      <RegionMap region={region} regions={regions} />
    </MapContextProvider>
  );
};
